import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { tablet, textStyles } from '../../theme';
export default {
  container: {},
  wrapper: {
    maxWidth: function maxWidth(props) {
      var _props$theme;
      return "".concat((props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.maxWidth) / 10, "rem") || 'none';
    },
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  form: _objectSpread({
    '& > *': {
      maxWidth: '33.5rem',
      margin: 0,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    '& > * + *': {
      marginTop: '2.5rem'
    },
    '& > * + $formActions': {
      marginTop: '5.5rem',
      maxWidth: 'none'
    }
  }, tablet({
    '& > * + $formActions': {
      marginTop: '7rem'
    }
  })),
  formActions: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center'
  },
  forgotten: _objectSpread({}, textStyles.text),
  successMessage: _objectSpread(_objectSpread({}, textStyles.text), {}, {
    textAlign: 'center'
  }),
  backLink: {
    textAlign: 'center'
  }
};